<invoice-cash-desk-edit (onClose)="close()"></invoice-cash-desk-edit>
